import React, { type ReactNode } from 'react';

import { SvgIcon, Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

import { OnboardingCallout } from './onboarding-callout';

type OnboardingNoticeProps = {
  children: ReactNode;
};

/** Light blue info callout (gradient + blue border) shown under the form in step 1. */
export function OnboardingNotice({ children }: OnboardingNoticeProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <OnboardingCallout align="flex-start" gap={scale(4)}>
      <SvgIcon name="IcInfo" size={scale(20)} color={guardianColors['Main/Main']} />
      <Text variant="Font Guardian App/Subtitle/Subtitle 12 Regular" style={styles.text}>
        {children}
      </Text>
    </OnboardingCallout>
  );
}

const useStyles = createStyles(() => ({
  text: {
    flex: 1,
    color: colors['10'],
  },
}));

export default OnboardingNotice;
